/**
 * Progress state slice - everything derived from the practice log (see progressRules.ts).
 */
export const progressSlice = {
    loaded: false,
    source: "local",     // "local" (visitor, this device) | "server" (account)
    summary: null,       // result of computeProgress(): { totalXp, belt, streak, lines, achievements, ... }
    imported: 0,         // practices moved from this device into the account at login
    anonymousLimit: 2,   // practices a visitor can complete before being asked to log in (0 = no limit)
};
